"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BurgerMenuToggle = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _BurgerMenuIcon = require("../BurgerMenuIcon");
var _constants = require("../constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const BurgerMenuToggle = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.BurgerMenuToggleRoot, {
    "data-testid": getTestId(_constants.BURGER_MENU_TOGGLE_ROOT),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_BurgerMenuIcon.BurgerMenuIcon, {})
  });
};
exports.BurgerMenuToggle = BurgerMenuToggle;